var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Button from '../button';
import Icon from '../icon';
var ImagesPanel = /** @class */ (function (_super) {
    __extends(ImagesPanel, _super);
    function ImagesPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.callBack = function (path) {
            if (_this.props.onChangeImage) {
                _this.props.onChangeImage(path);
            }
        };
        _this.onUpload = function (e, d) {
            if (_this.props.onUploadClick) {
                _this.props.onUploadClick(e, d);
            }
        };
        return _this;
    }
    ImagesPanel.prototype.render = function () {
        var _this = this;
        var images = this.props.images.map(function (image, idx) { return (React.createElement("div", { onClick: function () { return _this.callBack(image); }, key: "bg-images-" + idx, className: "thumbnail-box", style: {
                backgroundImage: "url(" + image.url + ")",
            } })); });
        return (React.createElement("div", { className: "image-container", style: { overflowY: 'auto', overflowX: 'hidden' } },
            React.createElement(Button, { upload: true, onClick: this.onUpload },
                React.createElement("span", { className: "button-wrapper" },
                    React.createElement(Icon, { name: "plus" }),
                    React.createElement("span", null, "Upload"))),
            images));
    };
    return ImagesPanel;
}(React.Component));
export default ImagesPanel;
//# sourceMappingURL=imagesPanel.js.map